// extracted by mini-css-extract-plugin
export default {"popoverPaper":"popoverPaper--SElzF"};